import React from 'react';
import { AlertTriangle, Snowflake, Thermometer, Umbrella } from '@/components/icons';
import { cn } from '@/lib/utils';

const STYLES = {
  dry: { label: 'Secco', Icon: Umbrella, className: 'border-amber-200 bg-amber-50 text-amber-800' },
  fresh: { label: 'Fresco', Icon: Thermometer, className: 'border-sky-200 bg-sky-50 text-sky-800' },
  frozen: { label: 'Surgelato', Icon: Snowflake, className: 'border-blue-200 bg-blue-50 text-blue-800' },
};

export default function StorageBadge({ value, bare = false, className: extraClassName }) {
  const { label, Icon, className } = STYLES[value] || {
    label: 'Conservazione da definire',
    Icon: AlertTriangle,
    className: 'border-slate-200 bg-slate-50 text-slate-700',
  };
  return <span className={cn('inline-flex items-center gap-1 text-xs', bare ? 'font-medium' : 'rounded-md border px-1.5 py-0.5', className, bare && 'border-0 bg-transparent p-0', extraClassName)}>
    <Icon className="h-3.5 w-3.5" aria-hidden="true" />{label}{value === 'fresh' && <span className="whitespace-nowrap">0–4 °C</span>}
  </span>;
}
